import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../utils/api';
import './Auth.css';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError(t('auth.passwordsMismatch'));
      return;
    }

    if (formData.password.length < 6) {
      setError(t('auth.passwordTooShort'));
      return;
    }

    setLoading(true);

    try {
      await api.post('/auth/reset-password', {
        token,
        newPassword: formData.password,
      });
      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="auth-page student-auth">
        <div className="auth-container">
          <div className="auth-header">
            <div className="role-icon" style={{ background: '#ef4444' }}>⚠️</div>
            <h1>{t('auth.invalidLink')}</h1>
            <p>{t('auth.invalidLinkDesc')}</p>
          </div>

          <div className="auth-links" style={{ marginTop: '30px' }}>
            <Link to="/forgot-password" className="btn-primary btn-student" style={{ textAlign: 'center', textDecoration: 'none', display: 'block', padding: '12px' }}>
              {t('auth.requestNewLink')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-page student-auth">
        <div className="auth-container">
          <div className="auth-header">
            <div className="role-icon" style={{ background: '#10b981' }}>✓</div>
            <h1>{t('auth.passwordResetSuccess')}</h1>
            <p>{t('auth.passwordResetSuccessDesc')}</p>
          </div>

          <div className="success-message">
            <p>{t('auth.canSignInNow')}</p>
            <p>{t('auth.redirectingLogin')}</p>
          </div>

          <div className="auth-links" style={{ marginTop: '30px' }}>
            <Link to="/login" className="btn-primary btn-student" style={{ textAlign: 'center', textDecoration: 'none', display: 'block', padding: '12px' }}>
              {t('auth.goToLogin')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page student-auth">
      <div className="auth-container">
        <div className="auth-header">
          <div className="role-icon student-icon">🔐</div>
          <h1>{t('auth.resetTitle')}</h1>
          <p>{t('auth.resetSubtitle')}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.newPassword')}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={t('auth.newPassword')}
              required
              minLength={6}
            />
          </div>

          <div className="form-group">
            <label>{t('auth.confirmPassword')}</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder={t('auth.confirmPassword')}
              required
            />
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary btn-student" disabled={loading}>
            {loading ? t('auth.resetting') : t('auth.resetConfirm')}
          </button>

          <p className="auth-link">
            {t('auth.rememberPassword')} <Link to="/login">{t('auth.signInLink')}</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
